import { render, staticRenderFns } from "./invite-clinic.vue?vue&type=template&id=4e03eb8b&"
import script from "./invite-clinic.vue?vue&type=script&lang=js&"
export * from "./invite-clinic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports